import { ADF } from "@atlassiansox/bxp-content-framework";

export function mockDocument({
    content = []
}: Partial<Pick<ADF.Document, "content">> = {}): ADF.Document {
    return {
        type: "doc",
        version: 1,
        content
    };
}
